import React from 'react';
import { Trash2, RefreshCw } from 'lucide-react';

const formatDay = (iso) => (iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }) : '');

export default function NotFoundTab({ errors, onClear, onCreateRedirect }) {
  return (
    <div data-testid="not-found-tab">
      <div className="flex items-center justify-between mb-4">
        <p className="text-xs text-earth/40 font-sans">Broken URLs detected on your site. Create redirects to fix them.</p>
        {errors.length > 0 && (
          <button onClick={onClear} className="text-xs font-sans text-red-500 font-semibold hover:text-red-600 flex items-center gap-1" data-testid="clear-404s"><Trash2 size={11} /> Clear All</button>
        )}
      </div>
      <div className="space-y-2">
        {errors.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg border border-saffron-100/50" data-testid="no-404s">
            <RefreshCw size={28} className="text-green-400 mx-auto mb-2" />
            <p className="text-earth/40 font-sans text-sm">No 404 errors detected</p>
          </div>
        ) : errors.map(e => (
          <div key={e.id || e.path} className="bg-white rounded-lg border border-red-200 p-3 flex items-center gap-3" data-testid={`error-404-${e.path.replace(/\//g, '-')}`}>
            <span className="text-[10px] font-sans font-bold bg-red-100 text-red-500 px-2 py-0.5 rounded">404</span>
            <span className="text-sm font-sans text-earth-dark flex-1 truncate">{e.path}</span>
            <span className="text-[10px] text-earth/30 font-sans">{e.count}x</span>
            <span className="text-[10px] text-earth/30 font-sans">{formatDay(e.last_seen)}</span>
            <button onClick={() => onCreateRedirect(e.path)} className="text-[10px] font-sans text-saffron font-semibold hover:text-saffron-dark" data-testid={`create-redirect-${e.path.replace(/\//g, '-')}`}>
              Create Redirect
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
